"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var HomeHeroSlider_1 = __importDefault(require("../../components/HomeHeroSlider"));
var HomeSearchForm_1 = __importDefault(require("../../components/HomeSearchForm"));
var HomeListingRow_1 = __importDefault(require("../../components/HomeListingRow"));
var homeHeroSlidesSlice_1 = require("../../features/homeHeroSlides/homeHeroSlidesSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NewHome = function () {
    var _a;
    var dispatch = react_redux_1.useDispatch();
    var slides = react_redux_1.useSelector(homeHeroSlidesSlice_1.selectHomeHeroSlides);
    var slidesStatus = react_redux_1.useSelector(homeHeroSlidesSlice_1.selectHomeHeroSlidesStatus);
    react_1.useEffect(function () {
        window.scroll(0, 0);
        // Slides stay in the store, so coming back to the page doesn't refetch.
        if (slidesStatus === 'idle') {
            dispatch(homeHeroSlidesSlice_1.getHomeHeroSlides());
        }
    }, []);
    // 1. While loading, keep a same-size card on the right so the layout doesn't jump.
    // 2. Loaded with slides -> show the slider.
    // 3. Loaded empty or failed -> no right column; the search form takes the full width.
    var isSlidesLoading = slidesStatus === 'idle' || slidesStatus === 'loading';
    var hasSlides = slides.length > 0;
    var hasSliderColumn = isSlidesLoading || hasSlides;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: styles_module_scss_1.default.hero },
            react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.hero_inner, (_a = {},
                    _a[styles_module_scss_1.default.hero_inner_single] = !hasSliderColumn,
                    _a)) },
                react_1.default.createElement(HomeSearchForm_1.default, null),
                isSlidesLoading && (react_1.default.createElement("div", { className: styles_module_scss_1.default.slider_placeholder })),
                !isSlidesLoading && hasSlides && (react_1.default.createElement(HomeHeroSlider_1.default, { slides: slides })))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.listings },
            react_1.default.createElement(HomeListingRow_1.default, { listingKey: "developer", icon: "\uD83C\uDFD7", searchQuery: "is_developer=true" }),
            react_1.default.createElement(HomeListingRow_1.default, { listingKey: "top", icon: "\u2B50", searchQuery: "" }),
            react_1.default.createElement(HomeListingRow_1.default, { listingKey: "tours3d", icon: "\uD83C\uDFA5", searchQuery: "has_3D_tour=true" }),
            react_1.default.createElement(HomeListingRow_1.default, { listingKey: "secondary", icon: "\uD83C\uDFE0", searchQuery: "is_developer=false" })),
        react_1.default.createElement(AppFooter_1.default, { layout: "HOME" })));
};
exports.default = NewHome;
